import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { FORM_PEDIDO_EGRESO_CALADO } from '../../../../config/forms'
import { renderRadioField } from '../../../Forms/fieldRenderers'

function CallesDeBruto (props) {
  const { dataCalles, onSelected = () => {} } = props
  const [calles, setCalles] = useState([])

  const fieldRef = useRef(null)

  useEffect(() => {
    const listadoCalles = []
    dataCalles && dataCalles.map((c) => {
      const calle = {
        fieldName: c.nombreCorto.trim(),
        name: c.nombre,
        label: c.nombre
      }

      listadoCalles.push(calle)
      return listadoCalles
    })

    setCalles(listadoCalles)
  }, [dataCalles])

  const handleKeyDown = (e) => {
    const { change: formChange } = props
    const value = `CALLE${e.key}`
    formChange('calleDeBruto', value)
  }

  const onSelectedCalleBruto = (calle) => {
    onSelected && onSelected(calle)
  }
  return (

    <div
      style={{ border: 'none', outline: 'none', display: 'flex', justifyContent: 'center' }}
      tabIndex={0}
      onKeyDown={handleKeyDown}
      ref={fieldRef}
    >
      <Field
        onChange={(value) => onSelectedCalleBruto(value)}
        name='calleDeBruto'
        label='Seleccionar calle de bruto'
        className='radio-field'
        options={calles}
        autoFocus
        placeholder='Calle de bruto *'
        component={(fieldProps) => (
          renderRadioField({
            ...fieldProps,
            wrapperStyle: { margin: 0, padding: 0, minHeight: 'auto', marginBottom: 0 }
          })
        )}
      />
    </div>

  )
}

const mapStateToProps = (state) => ({
  dataCalles: state.pesado.callesDeBruto
})

const mapActionsToProps = {}

const withReduxForm = reduxForm({
  form: FORM_PEDIDO_EGRESO_CALADO
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(withReduxForm(CallesDeBruto))
